import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import { getOnyxFixPreview, sendToKsefOnyxCorrection } from "@/requests/administration/administrationOnyxFix";
import { InvoiceData } from "@/models/api/administration/onyxFix/InvoiceData";

export interface AdministrationOnyxFixInterface {
  test: string;
}

export const AdministrationOnyxFixState: AdministrationOnyxFixInterface = {
  test: "test",
};

const AdministrationOnyxFixModule = defineModule({
  state: AdministrationOnyxFixState as AdministrationOnyxFixInterface,
  namespaced: true as const,
  getters: {},
  mutations: {},
  actions: {
    async downloadPreview(context, params: { file: File; data: InvoiceData }): Promise<void> {
      await getOnyxFixPreview(params.file, params.data);
    },
    async sendToKsef(context, params: { file: File; data: InvoiceData }): Promise<void> {
      await sendToKsefOnyxCorrection(params.file, params.data);
    },
  },
});
export default AdministrationOnyxFixModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationOnyxFixModule);
